module.exports = __webpack_public_path__ + "static/media/new-stone-illustration.c1bc75bc.svg";